export default {"src":"/uk/_next/static/media/hybrid-app-intro-screen-two.9dcc1ad2.svg","height":148,"width":300,"blurWidth":0,"blurHeight":0};